import { HOUR_MARKERS, COLORS } from "../constants";
import { formatHour } from "../utils";

export default () => (
  <div className="flex" style={{ borderBottom: `1px solid ${COLORS.white10}` }}>
    <div className="w-20 flex-shrink-0" style={{ backgroundColor: COLORS.navy }} />

    {/* Time labels row */}
    <div className="flex-1 relative h-8" style={{ backgroundColor: COLORS.navy }}>
      {HOUR_MARKERS.map((h) => (
        <div
          key={h}
          className="absolute text-xs -translate-x-1/2"
          style={{ left: `${(h / 24) * 100}%`, color: COLORS.white50, top: "50%", transform: "translate(-50%, -50%)" }}
        >
          {formatHour(h)}
        </div>
      ))}
    </div>
  </div>
);
